exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media screen and (min-width: 1100px){\n.card-header .btn-sm .plus[data-v-c32c7146]{display:none\n}\n}\n@media screen and (max-width: 1100px){\n.card-header .btn-sm .button-text[data-v-c32c7146]{display:none\n}\n.card-header .btn-sm .plus[data-v-c32c7146]{display:inline\n}\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-c32c7146","scoped":true,"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/t1/Person.vue
// module id = 1560
// module chunks = 0